
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import Step from '@/components/Step.vue';
    import StepProgression from '@/components/StepProgression.vue';
    import {ResponseGroup} from '@/lib/ResponseGroup';
    import Response from '@/lib/Response';
    import {api} from '@/Api';
    import store from '@/store';
    import {AxiosResponse} from 'axios';
    import {Question} from "@/lib/Question";

    @Component(
        {
            components: {
                Step,
                StepProgression,
            },
        })
    export default class ResponseGroupView extends Vue {
        @Prop() public branchSlug?: string;
        @Prop() public id?: number;
        @Prop() public entity?: string;
        @Prop() public hash?: string;
        public popup = false;
        public forced = false;
        public rgs = [];
        public currentBranch = null;
        public responseGroup = null;


        reload(){
            window.location.reload()
        }
        public getPicture(directory: string, pictureName: string) {
            return '/static/' + directory + '/' + pictureName
        }

        @Watch('$route', {immediate: true, deep: true})
        public load(newRoute: any, oldRoute: any) {
            
            store.commit('resetComparison');

            if (typeof oldRoute != typeof undefined) {
                if (oldRoute.name === 'questionnaire' && oldRoute.params.id === 0) {
                    return;
                }
            }
            store.commit('loading');

            this.currentBranch = store.getters.branchFromSlug(this.branchSlug);
            store.commit('showBranch', this.currentBranch);
            if (this.id == 0) {
               
                store.commit('reset');
                //     } else {
                if (this.hash) {
                    store.commit('setCurrentContractGroupUuid', this.hash);
                }
                
                const saved = api.getLocalResponseGroups();
                let existInBranch = false;
                this.rgs = [];
                saved.slice().reverse().forEach((rg) => {
                    if (rg.branchId === this.currentBranch.id) {
                        existInBranch = true;
                        this.rgs.push(rg);
                    }
                });
                if (existInBranch && !this.forced) {
                    store.commit('loaded');
                    return;
                }
            }

            this.loadResponseGroup();
        }

        private loadResponseGroup() {
            this.forced = true;
            store.commit('loading');
           
            if (this.id != 0) {
                const responseGroup = store.state.responseGroups.find((group: ResponseGroup) => {
                    return group.id === this.id && group.isLoaded;
                });
                if (responseGroup) {
                    responseGroup.branch.dispatchQuestions();
                    store.commit('setCurrentResponseGroup', responseGroup);
                    store.commit('setCurrentStep', responseGroup.getCurrentStep());
                    //store.commit('loaded');
                }
            }

            api.loadResponseGroup(store.state.currentBranch.id, this.id!).then(((response: AxiosResponse) => {
                if (response.status === 200) {

                    const data = response.data.data;
                    let responseGroup: ResponseGroup;
                    // api.deleteCookie(data.id);
                    let savedRG = api.getCookie('rg_' + data.id);
                    const b = store.state.branches.find((branch: any) => {
                        return branch.id === data.branch.id
                    });
                    if (!savedRG && b) {
                        const now = Date.now();
                        const cookie: string = b.slug + ',' + b.title + ',' + b.icon + ',' + now + ',' + b.id
                        let cookies = api.getLocalResponseGroups()
                        if (cookies.length > this.$store.state.maxRgCookies) {
                            api.deleteCookie('rg_' + cookies[0].uuid)
                        }
                        api.setCookie('rg_' + data.id, cookie);
                        api.loadRgs()
                    }

                    responseGroup = store.getters.responseGroup(this.id);
                    if (typeof responseGroup === typeof undefined) {
                        responseGroup = new ResponseGroup(store.state.currentBranch, data.creationDateFormatted);
                        responseGroup.id = data.id;
                        responseGroup.contractGroup = data.contractGroup;
                        store.commit('addResponseGroup', responseGroup);
                    }
                    const rawResponses = data.responses;

                    rawResponses.forEach((rawResponse: any) => {
                        let question = store.getters.getQuestion(rawResponse.question.id);
                        if (!question) {
                            return;
                        }
                        if (rawResponse.additionalIndex > 0 && question.section.multiple) {
                            const additional = question.section.getAdditionalOrCreateIfNotExist(rawResponse.additionalIndex);

                            question = additional.questions.find((question: Question) => question.originalId === rawResponse.question.id || question.id === rawResponse.question.id);
                            if (!question) {
                                return;
                            }
                        }
                        if (question) {
                            const responseObject = new Response(question, responseGroup, Question.transformBack(rawResponse.value, question.responseType.template), rawResponse.comment, rawResponse.valueId, rawResponse.id, rawResponse.customData);
                            responseObject.additionalIndex = rawResponse.additionalIndex;
                            store.commit('addResponse', responseObject);
                            question.loadingFromServer(responseObject);
                            // question.currentResponse = responseObject;
                        }
                        // console.log(question);
                        // console.log(store.getters.getQuestion(rawResponse.question.id));
                    });

                    responseGroup.isLoaded = true;
                    if (this.id == 0) {
                        // @ts-ignore
                        this.$router.replace({
                            name: 'questionnaire',
                            params: {branchSlug: responseGroup.branch.slug, id: responseGroup.id}
                        });
                    }

                    store.commit('setCurrentResponseGroup', responseGroup);
                    // debugger;
                    store.commit('setCurrentStep', responseGroup.getCurrentStep());
                    responseGroup.branch.dispatchQuestions();
                }
                store.commit('loaded');
            }));
        }
    }
